import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { EnvoirnmentService } from "../../services/envoirnment.service";

export interface ConfirmDynamicDialogData {
  confirm: string;
  displayText: string;
}

@Component({
  selector: "app-dynamic-confirm-dialog",
  templateUrl: "./confirm-dynamic-dialog.component.html",
  styleUrls: ["./confirm-dynamic-dialog.component.scss"]
})
export class ConfirmDynamicDialogComponent implements OnInit {
  translatedText: any;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDynamicDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: ConfirmDynamicDialogData,
    public translate: TranslateService,
    private env: EnvoirnmentService
  ) {
    translate.addLangs(["en", "id", "hn", "cn", "ms", "th","en_th"]);
    let language = localStorage.getItem("lan");
    if (language == 'en' && this.env.defaultLang == "en_th") {
        this.translate.use(this.env.defaultLang);
      } else if (language  && language !== "en") {
        this.translate.use(language);
      } else {
        this.translate.use(this.env.defaultLang? this.env.defaultLang : "en");
      }
    this.translate.get("dialogs").subscribe((data: any) => {
      this.translatedText = data[dialogData.displayText];
    });
    if(!this.translatedText)
        this.translatedText= dialogData.displayText 
  }

  ngOnInit() {}

  buttonClick(value) {
    let data = { confirm: value };
    this.dialogRef.close(data);
  }
}
